module.exports = __webpack_public_path__ + "img/event_winner_0625.c62267f8.png";